module.exports = __webpack_public_path__ + "media/images/features/search_for_information_img-3b287e5592bbff19c110893de486cdb5.png";